import { forwardRef } from "react";

import { Button, ButtonProps } from "@/components/_atoms/button";
import { IconDots } from "@/components/_icons/IconDots";
import { cn } from "@/lib/cn";

type MenuDotsButtonProps = Omit<ButtonProps, "children"> & { "aria-label": string };

export const MenuDotsButton = forwardRef<HTMLButtonElement, MenuDotsButtonProps>(
  ({ className, variant = "outline", size = "icon", ...props }, ref) => (
    <Button
      ref={ref}
      variant={variant}
      size={size}
      className={cn(
        "select-none rounded-md! text-muted-foreground data-[state=open]:bg-background!",
        className,
      )}
      {...props}
    >
      <IconDots className="h-4 w-4 shrink-0" />
    </Button>
  ),
);

MenuDotsButton.displayName = "MenuDotsButton";
